import { useState } from "react";
import { useData } from "../../providers/ContextProvider";
import { useNavigate } from "react-router-dom";
import AddHabitScoreCard from "../../components/AddHabitScoreCard";
import { BiNotepad } from "react-icons/bi";
import axios from "axios";
import "../../styles/general.css";
import "../../styles/queries.css";
import "../../styles/AddScore.css";

function AddScore() {
  const { state, dispatch } = useData();
  const { goals, scores: oldScores, lastDateScoreWasAdded } = state;
  console.log({ lastDateScoreWasAdded });
  const navigate = useNavigate();
  let initialState =
    goals.length > 0
      ? goals.map((goal) => {
          return { habitID: goal._id, unitsCompleted: "0" };
        })
      : [];

  const [scores, setScores] = useState(initialState);

  function inputChangeHandler(e, habitID) {
    let index = scores.findIndex((score) => score.habitID === habitID);
    console.log({ scores });
    scores[index] = { habitID, [e.target.name]: e.target.value };
    console.log({ scores });
    setScores([...scores]);
  }

  async function submitHandler(e) {
    e.preventDefault();
    const userID = JSON.parse(localStorage?.getItem("userID"));
    const token = JSON.parse(localStorage?.getItem("token"));
    // const currentDate = new Date().toISOString().slice(0, 10);
    console.log({ oldScores });
    const currentDate = new Date().toISOString();
    console.log({ lastDateScoreWasAdded });

    dispatch({
      type: "ADDSCORE",
      payload: {
        userID,
        scores: { score: scores, date: new Date().toISOString() },
      },
    });

    dispatch({
      type: "UPDATE_LAST_DATE_SCORE_WAS_ADDED",
      payload: currentDate,
    });

    navigate("/app/home");
  }

  return (
    <main className="main">
      {lastDateScoreWasAdded.slice(0, 10) ===
      new Date().toISOString().slice(0, 10) ? (
        <div className="add-score-text">
          Sorry! But you've already added a score for today!
        </div>
      ) : (
        <div className="form-container add-score-form-container">
          <h3 className="tertiary-heading form-heading">
            <BiNotepad />
            Add Score
          </h3>
          <div className="divider"></div>
          <form
            className="form add-score-form"
            method="post"
            onSubmit={(e) => submitHandler(e)}
          >
            <p>
              For a habit set as: "Reading","hour/hours","2", enter hours spent
              reading as score, weights will be calculated automaitcally. For 3
              hours spent reading score will be 3 and after considering weights
              will be 3(hours read)*2(2 points for every hour read)=6
            </p>
            {goals &&
              goals.map(({ habitName, _id: habitID }) => (
                <AddHabitScoreCard
                  key={habitID}
                  habitID={habitID}
                  habitName={habitName}
                  inputChangeHandler={inputChangeHandler}
                />
              ))}
            <button type="submit" className="btn btn-fill">
              Add Score
            </button>
          </form>
        </div>
      )}
    </main>
  );
}

export default AddScore;
